<template lang="pug">
    el-dialog(:title="!ruleForm.id ? '新建': '修改'", :fullscreen="false" :visible.sync='visible' :modal-append-to-body='false' :append-to-body='true' @close="closeForm()")
        el-form(:model="ruleForm", :inline="false" :rules="rules", ref="ruleForm", label-width="100px",label-position='left' @submit.native.prevent)
            el-card(shadow="never")
                el-form-item(label="会员账号:" prop='mobile')
                    el-input(type="text" v-model="ruleForm.mobile" @focus="checktable")
                el-form-item(label="姓    名:" prop='name')
                    el-input(type="text" v-model="ruleForm.name" @focus="checktable")
                el-form-item(label="代金券类型:" prop='type')
                    el-select(style='width:100%;' v-model="ruleForm.type" )
                        el-option(label='补课券' :value='1' )
                el-form-item(label="使用范围:" prop='rangeeSelect')
                    el-select(style='width:100%;'  v-model="ruleForm.rangeeSelect" multiple :remove-tag='removeTag')
                        el-option(v-for="item in rangeeArr" :key="item.value" :label="item.label" :value="item.value")
                el-form-item(label="有效期:" prop='couponDate')
                    el-date-picker(v-model="ruleForm.couponDate" range-separator="至" type="daterange" start-placeholder="开始时间" end-placeholder="截止时间" :picker-options="pickerOptions" format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable)
                el-form-item(label='备注:' prop='remark')
                    el-input(type="textarea" v-model="ruleForm.remark" :rows='5' resize='none')
        el-dialog(title="选择会员"  :visible.sync="addVisible" width="50%" :append-to-body='true' :modal-append-to-body='false')
            el-card(shadow="never")
                div(slot="header")
                    el-input(v-model='memberName' clearable='', style='width:80%;' placeholder="请输入姓名/级别/手机号码")
                    el-button(@click="getMemberData" style='float:right;' icon='el-icon-search') 查询
                div
                el-table(:data="memberData" @row-click="handleCurrentChange" border highlight-current-row @current-change="handleCurrentChange" max-height="300")
                    el-table-column(header-align='center' label='序号' align='center' width='80')
                        template(scope="scope")
                            el-radio(class="radio" v-model="radio" :label="scope.$index+1")
                    el-table-column(prop="name" label="姓名" align='center')
                    el-table-column(prop="gender" label="性别" align='center'  )
                        template(slot-scope="scope")
                            font(v-if="scope.row.gender === 0") 男
                            font(v-if="scope.row.gender === 1") 女
                    el-table-column(prop="level" label="级别" align='center')
                    el-table-column(prop="mobile" label="手机号码" align='center' )
                el-pagination(@size-change='sizeChangeHandle_mb', @current-change='currentChangeHandle_mb', :current-page='pageIndex_mb', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize_mb', :total='totalPage_mb', layout='total, sizes, prev, pager, next, jumper')
            span.dialog-footer(slot="footer")
                el-button(@click="checkMber" type="primary") 确 定
                el-button(@click="addVisible=false") 取 消

        span.dialog-footer(slot="footer")
            el-button(type="primary" @click="ruleFormSubmit()" :disabled="clickFlag") 确 定
            el-button(@click="closeForm()") 取 消
</template>
<script>
    export default {
        data () {
            return {
                clickFlag: false,
                addVisible: false,
                radio: '',
                memberData: [],
                memberName: '',
                pageIndex_mb: 1,
                pageSize_mb: 10,
                totalPage_mb: 0,
                checkedItem: {},
                ruleForm: {
                    id: null,
                    code: '',
                    type: 1,
                    rangee: '',
                    rangeeSelect: [],
                    couponDate: [],
                    startTime: null,
                    endTime: null,
                    remark: '',
                    mbId: '',
                    name: '',
                    mobile: ''
                },
                loading: null,
                visible: false,
                pickerOptions: {
                    disabledDate: time => {
                        return (
                            time < new Date() - 1000 * 60 * 60 * 24
                        )
                    }
                },
                rangeeArr: [
                    { label: '分级单次培训', value: '1' },
                    { label: '分级整期培训', value: '2' },
                    { label: '青少年儿童培训', value: '3' },
                    { label: '定制化培训', value: '4' }
                ],
                rules: {
                    name: [
                        { required: true, message: '会员姓名不能为空!', trigger: 'change' }
                    ],
                    mobile: [
                        { required: true, message: '会员账号不能为空!', trigger: 'change' }
                    ],
                    type: [
                        { required: true, message: '代金券类型不能为空!', trigger: 'change' }
                    ],
                    rangeeSelect: [
                        { required: true, message: '使用范围不能为空!', trigger: 'change' }
                    ],
                    couponDate: [
                        { required: true, message: '有效期不能为空!', trigger: 'change' }
                    ],
                    startTime: [
                        { required: true, message: '有效开始日期不能为空!', trigger: 'change' }
                    ],
                    endTime: [
                        { required: true, message: '有效结束日期不能为空!', trigger: 'change' }
                    ],
                    remark: [
                        { max: 500, message: '备注不能超过500个字符!', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            init (id) {
                this.clickFlag = false
                this.ruleForm.id = id || null
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['ruleForm'].resetFields()
                })
                //数据初始化
                this.ruleForm.startTime = ''
                this.ruleForm.endTime = ''
                this.ruleForm.couponDate = []
                this.ruleForm.rangeeSelect = []
                //修改回选
                if (this.ruleForm.id) {
                    this.$http({
                        url: this.$http.adornUrl(`/pbCoupon/getId/` + this.ruleForm.id),
                        method: 'get'
                    }).then((data) => {
                        if (data && data.code === 0) {
                            console.log('data:', data)
                            // this.ruleForm = data.bean
                            this.ruleForm.mbId = data.bean.mbId
                            this.ruleForm.id = data.bean.id
                            this.ruleForm.name = data.bean.name
                            this.ruleForm.mobile = data.bean.mobile
                            this.ruleForm.type = data.bean.type
                            this.ruleForm.remark = data.bean.remark
                            this.ruleForm.couponDate = []
                            this.ruleForm.rangeeSelect = []
                            this.ruleForm.couponDate.push(data.bean.startTime + '')
                            this.ruleForm.couponDate.push(data.bean.endTime + '')
                            this.ruleForm.rangeeSelect = data.bean.rangee.split(',')
                            console.log('this.ruleForm.rangeeSelect', this.ruleForm.rangeeSelect)
                        }
                    })
                }
            },
            openFullScreen () {
                this.loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },
            //新增方法
            ruleFormSubmit () {
                this.$refs['ruleForm'].validate((valid) => {
                    this.ruleForm.startTime = this.ruleForm.couponDate[0]
                    this.ruleForm.endTime = this.ruleForm.couponDate[1]
                    this.ruleForm.rangee = this.ruleForm.rangeeSelect.join(',')
                    if (valid) {
                       // this.openFullScreen()
                        this.clickFlag = true
                        console.log('要提交的代金券：', this.ruleForm.rangee)
                        this.$http({
                            url: this.$http.adornUrl(`/pbCoupon/${!this.ruleForm.id ? 'save' : 'update'}`),
                            method: 'post',
                            data: this.ruleForm
                        }).then((data) => {
                          //  this.loading.close()
                            if (data && data.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                                this.clickFlag = false
                            }
                        }).catch(e => {
                            this.$message.error('请求错误')
                            this.clickFlag = false
                        })
                    }
                })
            },
            closeForm () {
                this.visible = false
            },
            getMemberData () {
                this.pageIndex_mb = 1
                this.pageSize_mb = 10
                 this.$http({
                    url: this.$http.adornUrl(`/mbMember/getMemberList`),
                    method: 'post',
                    params: this.$http.adornParams({
                        'page': this.pageIndex_mb,
                        'rows': this.pageSize_mb,
                        'name': this.memberName,
                        'status': 1//只查询已实名认证的会员
                    })
                }).then(data => {
                    console.log('会员列表：', data)
                    if (data && data.code === 0) {
                        this.memberData = data.list.rows
                        this.totalPage_mb = data.list.total
                    } else {
                        this.memberData = []
                        this.totalPage_mb = 0
                    }
                })
            },
             // 每页数
            sizeChangeHandle_mb (val) {
                this.pageSize_mb = val
                this.pageIndex_mb = 1
                this.getMemberData()
            },
            // 当前页
            currentChangeHandle_mb (val) {
                this.pageIndex_mb = val
                this.getMemberData()
            },
            //选中某一条会员信息
            handleCurrentChange (val) {
                //赋值给radio
                this.radio = this.memberData.indexOf(val) + 1
                this.checkedItem = val
            },
            checkMber () {
                console.log(this.checkedItem)
                this.ruleForm.name = this.checkedItem.name
                this.ruleForm.mobile = this.checkedItem.mobile
                this.ruleForm.mbId = this.checkedItem.id
                this.addVisible = false
            },
            checktable () {
                this.getMemberData()
                this.addVisible = true
            },
            removeTag (val) {
                console.log('移除的tag', val)
            }
        }
    }
</script>
<style>
    .inputWidth{
        width: 210px;
    }

    .font_later{
        padding-left:20px;
        font-weight: bold;
        color: #909399;
    }
    .font_color{
        font-weight: bold;
        color: #909399;
    }
    .font_style{
        font-weight: bold;
        color: red;
    }
    .dialog-footer{
        padding-bottom:150px;
    }

    /* 提示框 */
.el-tooltip__popper.is-light{
  border: 1px solid #C0C4CC;
}

.el-tooltip__popper[x-placement^=bottom] .popper__arrow{
  border-bottom-color: grey  !important ;
}

.toolTip>p{
  margin: 0;
  padding-top: 10px;
  height:14px;
  line-height:14px;
  font-size:14px;
  color: #606266;
}

 /* 弹出遮罩层 兼容ie*/
.el-dialog__wrapper {
  width: 100% !important;
  height: 100% !important;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}

</style>
